<template>
	<div class="relative">
    <div class="row orange-bar" v-if="mixedSteps">
			<div class="mixedsteps pointer" v-for="(item, index) in mixedSteps" v-bind:key="item.id" v-bind:class="[(index == current) ? 'active' : 'inactive',(index == current && current != mixedSteps.length - 1) ? 'current' : '', 'items-' + mixedSteps.length]" v-on:click="slideToPage(mixedSteps[index == 0 ? 0 : index - 1], index)">
				<span class="circle">{{ index + 1 }}</span><span class="text">{{ item.title }}</span>
        <span class="back"></span>
			</div>
		</div>
    <div class="row grey-bar" v-if="mixedSteps">
			<div v-for="(item, index) in mixedStepsLength" v-bind:key="index" v-bind:class="[ isLast(index) ? 'bar-items' :'', 'grey-items-' + (mixedSteps.length)]"  class="pointer" v-on:click="slideToPage(mixedStepsLength[index == 0 ? 0 : index - 1], index)">
        <div class="bar-item-added" v-if="item.selected && item.selected_image">
          <img :src="item.selected_image ? item.selected_image : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'" alt class="selected_image" />
          <span class="selected_text"  v-if="item.selected && item.selected_image" v-bind:class="[isLongTitle(item) ? 'long-title' : '']">
            {{ item.selected && item.selected_title ? item.selected_title : item.title }}
          </span>
        </div>
        <!-- <span v-if="!item.selected || !item.selected_image" class="placeholder_image">
        </span> -->
			</div>
		</div>


    <div v-if="solution" class="solution-title">
      <h1>{{ solution.title }}</h1>
      <hr style="margin: 20px auto;">       
    </div>

    <div v-show="selectedVehicle.full_name" id="vehicle-drilldown-back" class="row">

      <div class="col-12 col-lg-10">
        <p><strong>{{ label_your_vehicle }}: </strong>{{ selectedVehicle.full_name }}</p>
      </div>

      <div id="vehicle-drilldown-back-back" class="col-12 col-lg-2">
        <a :href="back_url" class="btn btn-hover btn-primary">{{ label_back }}</a>
      </div>            
    </div>   


    <div class="row select-text" v-if="mixedSteps">
      <div v-for="(item, index) in mixedSteps" v-bind:key="item.id">
        <span v-if="index == current && index < mixedSteps.length - 1">
          <!-- Select {{ item.title }} -->
        </span>
        <span v-if="index == current && index == mixedSteps.length - 1">
          View {{ item.title }}
        </span>
			</div>
    </div>


	<div id="solution-slider">
		<transition-group tag="div" :name="transitionName" id="slider-group">
			<div v-if="show && mixedSteps && mixedSteps.length && mixedSteps[current]" :key="current" class="solution-slide row">

        <solution-categories
            v-if="(mixedSteps[current].type == 'category')"
            v-on:selectCategory="selectCategory($event)"
            :mixedStep = "mixedSteps[current]"
            :label_na_for_your_vehicle="label_na_for_your_vehicle"
          >
        </solution-categories>

        <solution-specs
            v-if="(mixedSteps[current].type == 'specification')"
            v-on:selectSpecification="selectSpecification($event)"
            :mixedStep = "mixedSteps[current]"
            :features = "features"
            :label_na_for_your_vehicle="label_na_for_your_vehicle"
            v-on:skipStep="skipStep($event)"
          >
        </solution-specs>

        <solution-products
            v-if="(mixedSteps[current].type == 'product')"
            v-on:selectProduct="selectProduct($event)"
            :mixedStep = "mixedSteps[current]"
            :currency_suffix="currency_suffix"
            :int_curr_symbol="int_curr_symbol"
            :label_complete_kit="label_complete_kit"
            :label_whats_included="label_whats_included"
            :label_qty="label_qty"
            :label_view="label_view"
            :label_solution="label_solution"
            :label_products="label_products"
            :label_Bar="label_Bar"
            :label_Bars="label_Bars"
          >
        </solution-products>

			</div>
		</transition-group>
	</div>

  <!-- div class="btn-vue btn-vue-prev"
    aria-label="Previous slide"
    style = "cursor:pointer"
    @click="slide(-1)"
    v-if="current">
    <img src="/cdn/images/solutions/left.svg" />
  </div>
  <div class="btn-vue btn-vue-next"
    aria-label="Next slide"
    style = "cursor:pointer"
    @click="slide(1)"
    v-if="((current + 1) != mixedSteps.length) && mixedSteps[current] && mixedSteps[current].selected"
    >
    <img src="/cdn/images/solutions/right.svg" />
  </div -->
</div>
</template>
<script>
import solutionCategories from "./solution-categories";
import solutionSpecs from "./solution-specs";
import solutionProducs from "./solution-products";

import * as SOLUTION_IMAGE from "./images";
import * as PRODUCT_CATEGORY from "./images/categories";

export default {
  name: "solution-slider",
  props: {
    solutionCategories: Object,
    int_curr_symbol: {
      type: String,
      default: "AUD"
    },
        selectedVehicle: {
      type: Object
    },
    currency_suffix: {
      type: String,
      default: "(RRP inc GST)"
    },
    label_whats_included: {
      type: String,
      default: "What's Included"
    },
    label_qty: {
      type: String,
      default: "Qty"
    },
    label_view: {
      type: String,
      default: "View"
    },
    label_solution: {
      type: String,
      default: "Solution"
    },
    label_products: {
      type: String,
      default: "Products"
    },
    label_Bar: {
      type: String,
      default: "Bar"
    },
    label_Bars: {
      type: String,
      default: "Bars"
    },
    label_complete_kit: {
        type: String,
        default: "Complete Kit"
    },
    label_na_for_your_vehicle: {
        type: String,
        default: "Not available for your vehicle"
    },
    label_back: {
        type: String,
        default: "Back"
    },    
    label_your_vehicle: {
        type: String,
        default: "Your vehicle"
    },  
     
    back_url: {
        type: String,
        default: "/"
    },    
    solution: {
        type: Object,

    },    

  },
  components : {
      'solution-categories': solutionCategories,
      'solution-specs': solutionSpecs,
      'solution-products': solutionProducs,
  },
  data: function() {
    return {
      mixedSteps : [],
      mixedStepsOriginal : [], // just a copy of mixed steps
      mixedStepsNoSpec: [],
      current: 0,
      direction: 1,
      transitionName: "fade",
      show: true,
      specifications : [],
      features : [],
      imageMatrix : {
            // Cross bar systems
            '3B393703-FAA0-4701-A5B4-DFA329A3DC9B' : { //vortex
                '30D68F7A-9767-4A85-A202-7E2D36DDA630' : { // overhang
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/vortex-overhang-bar.jpg',
                    },
                },
                '3492BB0B-E151-4006-B785-A2E65269871B' : { // flush bar
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/vortex-flush-bar.jpg',
                    },
                },
                'generic' : { // no specific
                    '13EE9F51-90CA-4128-9C57-2DB36ED18057' : { // black
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/vortex-black.jpg',
                          },
                    },
                    'F7A121FE-A2B0-4E02-ACB5-70D50B3EE53B' : { // silver
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/vortex-silver.jpg',
                          },
                    },
                    'generic' : {
                        '8EB4B405-C7C4-41F7-BE11-B68D01FAE7DC' : { // Roof Rail Mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Images/Solution/vortex-roof-rail-mount-rx100.jpg'}},
                        'F3B62232-BF24-465B-85FC-31F14EEFE3C8' : { // Track mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-track-mount.jpg'}},
                        '333D6489-6025-4657-AEE3-98A1C17C464C' : { // Ditch mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-ditch-mount.jpg'}},
                        '145F0358-820E-4757-BC2C-B69CC2B2204A' : { // Bare roof mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-bare-roof-mount.jpg'}},
                        'D36EB0FC-CB72-4D3F-8327-9FAC593231DE' : { // Gutter mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-rl110-gutter-mount.jpg'}},
                        '8AFDD8CE-13F0-489B-8D12-7884C00198C7' : { // Factory point
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-rch-factory-mounting-point.jpg'}},
                        'F2C3F9C7-D860-4B55-BF23-08EAE5C9143F' : { // Existing point
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-bare-roof-mount.jpg'}},
                    }
                },
            },
            '863D439D-B6F2-48F1-BA51-9EEA6A2228E3' : { //heavy duty
                '30D68F7A-9767-4A85-A202-7E2D36DDA630' : { // overhang
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-overhang-bar.jpg',
                    },
                },
                'generic' : { // no specific
                    '13EE9F51-90CA-4128-9C57-2DB36ED18057' : { // black
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-black.jpg',
                          },
                    },
                    'F7A121FE-A2B0-4E02-ACB5-70D50B3EE53B' : { // silver
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-silver.jpg',
                          },
                    },
                    'generic' : {
                        'F3B62232-BF24-465B-85FC-31F14EEFE3C8' : { // Track mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-track-mount.jpg'}},
                        '333D6489-6025-4657-AEE3-98A1C17C464C' : { // Ditch mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-ditch-mount.jpg'}},
                        '145F0358-820E-4757-BC2C-B69CC2B2204A' : { // Bare roof mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-bare-roof-mount.jpg'}},
                        '339F839F-379F-40B8-8009-2131C1D6408A' : { // Retro mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-retro-track-mount.jpg'}},
                        'D36EB0FC-CB72-4D3F-8327-9FAC593231DE' : { // heavy-duty-gutter-mount.jpg
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-gutter-mount.jpg'}},
                        '8AFDD8CE-13F0-489B-8D12-7884C00198C7' : { // heavy-duty-factory-mounting-point.jpg
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-factory-mounting-point.jpg'}},
                        'F2C3F9C7-D860-4B55-BF23-08EAE5C9143F' : { // heavy-duty-existing-vehicle-track-mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-existing-vehicle-track-mount.jpg'}},
                    }
                },
            },
            '43953A77-B713-45AC-BF16-453340992E82' : { //Euro
                '30D68F7A-9767-4A85-A202-7E2D36DDA630' : { // overhang
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/euro-overhang-bar.jpg',
                    },
                },
                'generic' : { // no specific
                    '13EE9F51-90CA-4128-9C57-2DB36ED18057' : { // black
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/euro-black.jpg',
                          },
                    },
                    'generic' : {
                        '333D6489-6025-4657-AEE3-98A1C17C464C' : { // Ditch mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/euro-ditch-mount.jpg'}},
                        '145F0358-820E-4757-BC2C-B69CC2B2204A' : { // Bare roof mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/euro-bare-roof-mount.jpg'}},
                        '8AFDD8CE-13F0-489B-8D12-7884C00198C7' : { // heavy-duty-factory-mounting-point.jpg
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/euro-factory-mounting-point.jpg'}},
                        '8EB4B405-C7C4-41F7-BE11-B68D01FAE7DC' : { // Roof Rail Mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Images/Solution/vortex-roof-rail-mount-rx100.jpg'}},
                    }
                },
            },
            // Pioneer systems
            '5B45A723-3C5D-4822-B5A6-BAD5DD250D1E' : { //Pioneer Platform
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-backbone.jpg'}}, // Backbone
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rch.jpg'}}, // RCH
                'ABF152AA-4F62-4DC9-9B54-3D89E668B80C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-sx.jpg'}}, // SX
                '3F14EB95-4454-41D0-A8BC-0F6C5625FC02' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rcl.jpg'}}, // rcl
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            '05E803A7-793A-4E6A-A1AA-C1B163BDDF5A' : { //Complete kits
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-backbone.jpg'}}, // Backbone
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rch.jpg'}}, // RCH
                'ABF152AA-4F62-4DC9-9B54-3D89E668B80C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-sx.jpg'}}, // SX
                '3F14EB95-4454-41D0-A8BC-0F6C5625FC02' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rcl.jpg'}}, // rcl
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            'F56358A7-D643-45F7-A974-6A4B3E32F820' : { //Pioneer Tray
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tray-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tray-backbone.jpg'}}, // Backbone
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tray-rch.jpg'}}, // RCH
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            '0763DB5B-024D-4F37-901D-C483BA83712B' : { //Pioneer Tradie
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{ // Backbone
                      'default' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-backbone.jpg',
                      'D9B0285D-2703-4DF7-87D6-117A36FEDA14' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-jeep-backbone.jpg'}}, //RRI-239
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-rch.jpg'}}, // RCH
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            '05E803A7-793A-4E6A-A1AA-C1B163BDDF5A' : { //Complete kits
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-backbone.jpg'}}, // Backbone
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rch.jpg'}}, // RCH
                'ABF152AA-4F62-4DC9-9B54-3D89E668B80C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-sx.jpg'}}, // SX
                '3F14EB95-4454-41D0-A8BC-0F6C5625FC02' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rcl.jpg'}}, // rcl
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            // Double Ladder Rack - categoryId - PR_CategoryMeta table
            'F7380C9C-AF6D-4B3D-82C9-17E81216DCA2' : { 
                '7DAE29DC-5160-48CB-8B41-EEADF8A91B49': {
                  'image' :{'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-silver.jpg'},
                  '97F3F927-0B65-4B95-9A44-687832E5FAF9': {  // 4.0m
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  '41C92E0C-600F-4617-90A8-558AC39376F6': { // 3.5m
                       'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : {// Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E534853E-4E2F-4D86-9A0F-09ACF7D03E0E': { // 3.0m
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E043A727-2A85-4094-B500-FBCC64065FAE': { // 2.6m
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                },
                '8C01F2EF-B517-479D-A9CC-DC3DD2839E32': {
                  'image' :{'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-black.jpg'},
                  '97F3F927-0B65-4B95-9A44-687832E5FAF9': {  // 4.0m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  '41C92E0C-600F-4617-90A8-558AC39376F6': { // 3.5m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E534853E-4E2F-4D86-9A0F-09ACF7D03E0E': { // 3.0m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E043A727-2A85-4094-B500-FBCC64065FAE': { // 2.6m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                },
            },
            // Single Ladder Rack - categoryId - PR_CategoryMeta table
            '2B39426A-55C6-45D5-9418-5A79A0166DEA' : { 
                '7DAE29DC-5160-48CB-8B41-EEADF8A91B49': {  // Bar Colour - Silver
                  'image' :{'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-silver.jpg'},
                  '97F3F927-0B65-4B95-9A44-687832E5FAF9': { // 4.0m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  '41C92E0C-600F-4617-90A8-558AC39376F6': { // 3.5m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E534853E-4E2F-4D86-9A0F-09ACF7D03E0E': { // 3.0m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E043A727-2A85-4094-B500-FBCC64065FAE': { // 2.6m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit 
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                },
                '8C01F2EF-B517-479D-A9CC-DC3DD2839E32': { // Bar Colour - Black
                  'image' :{'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-black.jpg'},
                  '97F3F927-0B65-4B95-9A44-687832E5FAF9': { // 4.0m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  '41C92E0C-600F-4617-90A8-558AC39376F6': { // 3.5m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E534853E-4E2F-4D86-9A0F-09ACF7D03E0E': { // 3.0m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : {  // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                  'E043A727-2A85-4094-B500-FBCC64065FAE': { // 2.6m
                    'image' :{'default' : 'https://assets.rhinorack.com/Images/PageImages/Placeholder/Image-Coming-Soon.jpg'},
                    '2D15F994-87B0-4F9C-A8AB-8AF5BBC26D1C': { // Add Conduit - With Conduit
                        'image' :{'default' : 'https://assets.rhinorack.com/Images/Accessories/P30-100/P30-100-Conduit-Carrier-00.jpg'}
                    },
                    '35755BCE-667A-438A-84A4-F9F924BC01FF' : { // Add Conduit - Without Conduit
                      'image' :{'default' : 'https://assets.rhinorack.com/Images/RoofRacks/no-conduit.jpeg'}
                    }
                  },
                },
            },

            //RRI-415 changes

            // Cross bar systems
            '3590391A-05DF-4737-B44C-5A694414BF78' : { //vortex
                '30D68F7A-9767-4A85-A202-7E2D36DDA630' : { // overhang
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/vortex-overhang-bar.jpg',
                    },
                },
                '3492BB0B-E151-4006-B785-A2E65269871B' : { // flush bar
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/vortex-flush-bar.jpg',
                    },
                },
                'generic' : { // no specific
                    '13EE9F51-90CA-4128-9C57-2DB36ED18057' : { // black
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/vortex-black.jpg',
                          },
                    },
                    'F7A121FE-A2B0-4E02-ACB5-70D50B3EE53B' : { // silver
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/vortex-silver.jpg',
                          },
                    },
                    'generic' : {
                        '8EB4B405-C7C4-41F7-BE11-B68D01FAE7DC' : { // Roof Rail Mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Images/Solution/vortex-roof-rail-mount-rx100.jpg'}},
                        'F3B62232-BF24-465B-85FC-31F14EEFE3C8' : { // Track mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-track-mount.jpg'}},
                        '333D6489-6025-4657-AEE3-98A1C17C464C' : { // Ditch mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-ditch-mount.jpg'}},
                        '145F0358-820E-4757-BC2C-B69CC2B2204A' : { // Bare roof mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-bare-roof-mount.jpg'}},
                        'D36EB0FC-CB72-4D3F-8327-9FAC593231DE' : { // Gutter mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-rl110-gutter-mount.jpg'}},
                        '8AFDD8CE-13F0-489B-8D12-7884C00198C7' : { // Factory point
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-rch-factory-mounting-point.jpg'}},
                        'F2C3F9C7-D860-4B55-BF23-08EAE5C9143F' : { // Existing point
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/vortex-bare-roof-mount.jpg'}},
                    }
                },
            },
            'E066774F-2238-4E71-81E1-CE337394E32C' : { //heavy duty
                '30D68F7A-9767-4A85-A202-7E2D36DDA630' : { // overhang
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-overhang-bar.jpg',
                    },
                },
                'generic' : { // no specific
                    '13EE9F51-90CA-4128-9C57-2DB36ED18057' : { // black
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-black.jpg',
                          },
                    },
                    'F7A121FE-A2B0-4E02-ACB5-70D50B3EE53B' : { // silver
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-silver.jpg',
                          },
                    },
                    'generic' : {
                        'F3B62232-BF24-465B-85FC-31F14EEFE3C8' : { // Track mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-track-mount.jpg'}},
                        '333D6489-6025-4657-AEE3-98A1C17C464C' : { // Ditch mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-ditch-mount.jpg'}},
                        '145F0358-820E-4757-BC2C-B69CC2B2204A' : { // Bare roof mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-bare-roof-mount.jpg'}},
                        '339F839F-379F-40B8-8009-2131C1D6408A' : { // Retro mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-retro-track-mount.jpg'}},
                        'D36EB0FC-CB72-4D3F-8327-9FAC593231DE' : { // heavy-duty-gutter-mount.jpg
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-gutter-mount.jpg'}},
                        '8AFDD8CE-13F0-489B-8D12-7884C00198C7' : { // heavy-duty-factory-mounting-point.jpg
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-factory-mounting-point.jpg'}},
                        'F2C3F9C7-D860-4B55-BF23-08EAE5C9143F' : { // heavy-duty-existing-vehicle-track-mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/heavy-duty-existing-vehicle-track-mount.jpg'}},
                    }
                },
            },
            '857A29C5-2FAC-4A7C-80AE-6F2F057FD275' : { //Euro
                '30D68F7A-9767-4A85-A202-7E2D36DDA630' : { // overhang
                    'image' :{
                      'default' : 'https://assets.rhinorack.com/Solution/euro-overhang-bar.jpg',
                    },
                },
                'generic' : { // no specific
                    '13EE9F51-90CA-4128-9C57-2DB36ED18057' : { // black
                        'image' :{
                            'default' : 'https://assets.rhinorack.com/Solution/euro-black.jpg',
                          },
                    },
                    'generic' : {
                        '333D6489-6025-4657-AEE3-98A1C17C464C' : { // Ditch mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/euro-ditch-mount.jpg'}},
                        '145F0358-820E-4757-BC2C-B69CC2B2204A' : { // Bare roof mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/euro-bare-roof-mount.jpg'}},
                        '8AFDD8CE-13F0-489B-8D12-7884C00198C7' : { // heavy-duty-factory-mounting-point.jpg
                            'image' : {'default' : 'https://assets.rhinorack.com/Solution/euro-factory-mounting-point.jpg'}},
                        '8EB4B405-C7C4-41F7-BE11-B68D01FAE7DC' : { // Roof Rail Mount
                            'image' : {'default' : 'https://assets.rhinorack.com/Images/Solution/vortex-roof-rail-mount-rx100.jpg'}},
                    }
                },
            },
            // Pioneer systems
            '1A5234F0-547F-42A2-BE5C-9E8517BCC568' : { //Pioneer Platform
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-backbone.jpg'}}, // Backbone
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rch.jpg'}}, // RCH
                'ABF152AA-4F62-4DC9-9B54-3D89E668B80C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-sx.jpg'}}, // SX
                '3F14EB95-4454-41D0-A8BC-0F6C5625FC02' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rcl.jpg'}}, // rcl
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            '05E803A7-793A-4E6A-A1AA-C1B163BDDF5A' : { //Complete kits
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-backbone.jpg'}}, // Backbone
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rch.jpg'}}, // RCH
                'ABF152AA-4F62-4DC9-9B54-3D89E668B80C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-sx.jpg'}}, // SX
                '3F14EB95-4454-41D0-A8BC-0F6C5625FC02' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rcl.jpg'}}, // rcl
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            '8117FA4F-4F18-47DE-8FF3-98E91BC1A357' : { //Pioneer Tray
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tray-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tray-backbone.jpg'}}, // Backbone
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tray-rch.jpg'}}, // RCH
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            'E12B3B61-DA1A-4AA9-9907-37E290781D95' : { //Pioneer Tradie
                'FAA5F9DA-DDB6-46F3-A346-F1750D541D47' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-rlt600.jpg'}}, // RLT600
                '8B84CD36-FAD8-43DD-BEB2-A8DA2C86EDA8' : {'image' :{ // Backbone
                      'default' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-backbone.jpg',
                      'D9B0285D-2703-4DF7-87D6-117A36FEDA14' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-jeep-backbone.jpg'}}, //RRI-239
                '15BB5D02-A2F6-4C55-A2D1-C8A9A4C4177C' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-tradie-rch.jpg'}}, // RCH
                'BBF152AA-4F62-4DC9-9B54-3D89E668B80D' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx100.jpg'}}, // rx100
                'DC651DDE-2925-4B9A-9202-A92034EE4526' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-rx300.jpg'}}, // rx300
                'C1B4A003-3746-4450-88C7-15036065C148' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                '9DF8D7FE-E1DF-4CE2-8682-56ED86F945FE' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'A47D1351-02E8-4EBA-ACFD-5F8A44389444' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
                'C98C61B5-9475-40B6-B113-CC333975BD10' : {'image' :{'default' : 'https://assets.rhinorack.com/Solution/pioneer-platform-2500.jpg'}}, // 2500
            },
            // this is because staging db and prod are not sync - staging parts can be removed after syncing the databases
            [PRODUCT_CATEGORY.Reconn_Deck_with_Reconn_Deck_Bars_Staging] : SOLUTION_IMAGE.OVER_LANDING_BAR_QUANTITY,
            [PRODUCT_CATEGORY.Reconn_Deck_with_Vortex_Bars_Staging]: SOLUTION_IMAGE.VORTEX_BAR_QUANTITY,
            [PRODUCT_CATEGORY.Reconn_Deck_with_NS_Bars_Staging]: SOLUTION_IMAGE.NS_BAR_QUANTITY,
            // Keep these ones
            [PRODUCT_CATEGORY.Reconn_Deck_with_Reconn_Deck_Bars]: SOLUTION_IMAGE.OVER_LANDING_BAR_QUANTITY,
            [PRODUCT_CATEGORY.Reconn_Deck_with_Vortex_Bars]: SOLUTION_IMAGE.VORTEX_BAR_QUANTITY,
            [PRODUCT_CATEGORY.Reconn_Deck_with_NS_Bars]: SOLUTION_IMAGE.NS_BAR_QUANTITY,
          }
    };
  },
   computed: {
    vehicleId() {
      if(this.$store && this.$store.state && this.$store.state.solutions && this.$store.state.solutions.selectedVehicle)
        return this.$store.state.solutions.selectedVehicle.vehicleId;
      else
        return null;
    },
    mixedStepsLength: function () {
      return this.mixedSteps.slice(0,-1);
    }
  },
   mounted(){
      this.specifications = this.solutionCategories.specifications;
      this.features = this.solutionCategories.features;

      if(this.solutionCategories.categories && this.solutionCategories.type_text && this.solutionCategories.categories.length)
      {

        var items = [];

        for (var i = 0; i < this.solutionCategories.categories.length; i++) {

         items.push({
          'categoryId' : this.solutionCategories.categories[i].categoryId,
          'title' : this.solutionCategories.categories[i].title,
          'image' : this.solutionCategories.categories[i].imageUrl,
          'desc' : this.solutionCategories.categories[i].shortDescription,
          'product_count' : this.solutionCategories.categories[i].product_count,
          'category_meta' : this.solutionCategories.categories[i].category_meta,
        })
       }

       this.mixedSteps.push({'title' : this.solutionCategories.type_text,
        'type' : 'category',
        'items' : items,
        'selected' : null,
        'selected_image' : null,
        'selected_title' : null});
     }


     if(this.specifications && this.specifications.length)
       for (var i = 0; i < this.specifications.length; i++) {


        this.mixedSteps.push({'specificationId' : this.specifications[i]['specificationId'],
          'title' : this.specifications[i]['title'],
          'type' : 'specification',
          'selected' : null,
          'selected_image' : null,
          'selected_title' : null});
      }

      this.mixedSteps.push({'title' : 'Solutions',
        'type' : 'product',
        'items' : null });


     // re-visiting the url
    for (var i = 0; i < this.mixedSteps.length; i++) {
      var value =  this.getUrlParameter('p'+(i+1));
      if(value){
        this.mixedSteps[i].selected = value;
        this.slide(1);
      }

    }

    this.mixedStepsOriginal = this.mixedSteps;
    this.mixedStepsNoSpec   = this.mixedSteps.filter(step => { return !(step.type === "specification"); });

   },
   updated(){
     setTimeout(function() {
       var solutionItems = document.getElementsByClassName('solution-category');
       var solutionMaxHeight = 0;
       for(var i = 0; i < solutionItems.length; i++) {
         if (solutionItems[i].offsetHeight > solutionMaxHeight) {
            solutionMaxHeight = solutionItems[i].offsetHeight;
          }
       }
       for(var i = 0; i < solutionItems.length; i++) {
         solutionItems[i].style.height = solutionMaxHeight + 'px';
       }
       var specItems = document.getElementsByClassName('solution-spec');
       var specMaxHeight = 0;
       for(var i = 0; i < specItems.length; i++) {
         if (specItems[i].offsetHeight > specMaxHeight) {
            specMaxHeight = specItems[i].offsetHeight;
          }
       }
       for(var i = 0; i < specItems.length; i++) {
         specItems[i].style.height = specMaxHeight + 'px';
       }
       var productItems = document.getElementsByClassName('solution-product');
       var productMaxHeight = 0;
       for(var i = 0; i < productItems.length; i++) {
         if (productItems[i].offsetHeight > productMaxHeight) {
            productMaxHeight = productItems[i].offsetHeight;
          }
       }
       for(var i = 0; i < productItems.length; i++) {
         productItems[i].style.height = productMaxHeight + 'px';
       }
      if(document.getElementsByClassName('solution-slide') && document.getElementsByClassName('solution-slide').length)
      {
        var maxHeight = 0;
        var items = document.getElementsByClassName('solution-slide');
        for(var i = 0; i < items.length; i++) {
          if (items[i].offsetHeight > maxHeight) {
            maxHeight = items[i].offsetHeight;
          }
        }

          document.getElementById("slider-group").style.height = maxHeight + 'px';
        
      }
     }, 700)
   },
   methods: {
    returnImage(specsId){
        if(this.mixedSteps && this.mixedSteps[1] && !this.mixedSteps[1].selected)
        {

          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected][specsId]['image'][this.vehicleId]
              )
                return this.imageMatrix[this.mixedSteps[0].selected][specsId]['image'][this.vehicleId];
          else
          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected][specsId]['image']['default']
            )
              return this.imageMatrix[this.mixedSteps[0].selected][specsId]['image']['default'];
          else
            return null;
        }
        else
        if(this.mixedSteps && this.mixedSteps[2] && !this.mixedSteps[2].selected)
        {

          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]['image'][this.vehicleId]
              )
                return this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]['image'][this.vehicleId];
          else
          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]['image']['default']
            )
              return this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][specsId]['image']['default'];
          else
            if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected]['generic']
              && this.imageMatrix[this.mixedSteps[0].selected]['generic'][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected]['generic'][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected]['generic'][specsId]['image']['default']
            )
              return this.imageMatrix[this.mixedSteps[0].selected]['generic'][specsId]['image']['default'];
          else
            return null;
        }
        else
        if(this.mixedSteps && this.mixedSteps[3] && !this.mixedSteps[3].selected)
        {
          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]['image'][this.vehicleId]
              )
                return this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]['image'][this.vehicleId];
          else
          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]['image']['default']
              )
                return this.imageMatrix[this.mixedSteps[0].selected][this.mixedSteps[1].selected][this.mixedSteps[2].selected][specsId]['image']['default'];
          else
          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected]['generic']
              && this.imageMatrix[this.mixedSteps[0].selected]['generic'][this.mixedSteps[2].selected]
              && this.imageMatrix[this.mixedSteps[0].selected]['generic'][this.mixedSteps[2].selected][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected]['generic'][this.mixedSteps[2].selected][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected]['generic'][this.mixedSteps[2].selected][specsId]['image']['default']
              )
                return this.imageMatrix[this.mixedSteps[0].selected]['generic'][this.mixedSteps[2].selected][specsId]['image']['default'];
          else
          if (
              this.imageMatrix[this.mixedSteps[0].selected]
              && this.imageMatrix[this.mixedSteps[0].selected]['generic']
              && this.imageMatrix[this.mixedSteps[0].selected]['generic']['generic']
              && this.imageMatrix[this.mixedSteps[0].selected]['generic']['generic'][specsId]
              && this.imageMatrix[this.mixedSteps[0].selected]['generic']['generic'][specsId]['image']
              && this.imageMatrix[this.mixedSteps[0].selected]['generic']['generic'][specsId]['image']['default']
              )
                return this.imageMatrix[this.mixedSteps[0].selected]['generic']['generic'][specsId]['image']['default'];
          else
            return null;
        }
        if(specsId == 'BBF152AA-4F62-4DC9-9B54-3D89E668B80D'){
            return 'https://assets.rhinorack.com/Images/Solution/crossbar-systems-leg-RX100.jpg';
        }
        return null;
    },
    isLast(index) {
      return this.mixedSteps[index + 1].selected ? false : true
    },
    isLongTitle(item) {
       let title = item.selected && item.selected_title ? item.selected_title : item.title;
        return title.length >= 17; 
    },
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    setUrl() {
      var path = window.location.pathname;

      var s_variable = this.getUrlParameter('s');

      if(s_variable) path = path + '?s=' + s_variable;

      for (var i = 0; i < this.mixedSteps.length; i++) {
        if(this.mixedSteps[i].selected)
        path = path + '&p' + (i + 1) + '=' + this.mixedSteps[i].selected;
      }

      window.history.replaceState({}, null, path)
    },

    uniqueByKeepLast(data){
       var flags = [], output = [], l = data.length, i;

       for( i=0; i<l; i++) {
          if( flags[data[i].specificationPropertyMasterDataId]) continue;
          flags[data[i].specificationPropertyMasterDataId] = true;
          output.push(data[i]);
        }

       return output;
    },


    filterProductsBySpecs(products, specificationMasterDataId){
      var product_indexes = [];

      for (var j = 0; j < products.length; j++) {

                if(products[j].product_specification_properties)

                  for (var k = 0; k < products[j].product_specification_properties.length; k++) {

                    if(products[j].product_specification_properties[k].specificationPropertyMasterDataId == specificationMasterDataId)
                    {
                      product_indexes.push(j);
                    }

                  }
              }

        var return_products = [];
        for (var i = 0; i < product_indexes.length; i++) {
          if(products[product_indexes[i]])
          return_products.push(products[product_indexes[i]]);
        }

        return return_products;
    },

    slideToPage(item, page) {
      if (item.selected) {
        this.direction = this.current - page > 0 ? -1 : 1;
        this.direction === 1
          ? (this.transitionName = "slide-next")
          : (this.transitionName = "slide-prev");
        this.current = page;
      }
    },

    slide(dir) {

      this.direction = dir;
      dir === 1
      ? (this.transitionName = "slide-next")
      : (this.transitionName = "slide-prev");
      var len = this.mixedSteps.length;
      this.current = (this.current + dir % len + len) % len;

      var tmp_arr = [];
      if(this.current && (this.current != (this.mixedSteps.length -1)) && (dir == 1) && (this.mixedSteps[this.current] && !this.mixedSteps[this.current].selected))
      {
        if(this.solutionCategories.categories && this.solutionCategories.categories.length)
        {

          for (var i = 0; i < this.solutionCategories.categories.length; i++) {

            if(this.solutionCategories.categories[i].categoryId == this.mixedSteps[0].selected)
            {
              var products_in = this.solutionCategories.categories[i].products;

              for (var z = 1; z < this.mixedSteps.length; z++) {
                  if(this.mixedSteps[z].selected)
                  {
                    products_in = this.filterProductsBySpecs(products_in, this.mixedSteps[z].selected);
                  }

              }

                for (var j = 0; j < products_in.length; j++) {

                  if(products_in[j].product_specification_properties)

                    for (var k = 0; k < products_in[j].product_specification_properties.length; k++) {

                      if(products_in[j].product_specification_properties[k].specification_property && (products_in[j].product_specification_properties[k].specification_property.specificationId == this.mixedSteps[this.current].specificationId))
                      {
                        if(products_in[j].product_specification_properties[k].specification_property_master_data)
                        {
                          tmp_arr.push({
                            'specificationPropertyMasterDataId' :  products_in[j].product_specification_properties[k].specification_property_master_data.specificationPropertyMasterDataId,
                            'title' :  products_in[j].product_specification_properties[k].specification_property_master_data.title,
                            'image' : (products_in[j].p_r_medias && products_in[j].p_r_medias.length) ? (this.returnImage(products_in[j].product_specification_properties[k].specification_property_master_data.specificationPropertyMasterDataId) ? this.returnImage(products_in[j].product_specification_properties[k].specification_property_master_data.specificationPropertyMasterDataId) : products_in[j].p_r_medias[0].mediaUrl) : ''
                          })
                        }
                      }

                    }
                }
            }
          }
        }
      var specs_items = this.uniqueByKeepLast(tmp_arr);
      this.mixedSteps[this.current].items = specs_items;

      }

      if(this.current && this.current == (this.mixedSteps.length -1))
      {

        if(this.solutionCategories.categories && this.solutionCategories.categories.length)
          {

            for (var i = 0; i < this.solutionCategories.categories.length; i++) {

              if(this.solutionCategories.categories[i].categoryId == this.mixedSteps[0].selected)
              {
                var products_in = this.solutionCategories.categories[i].products;

                for (var z = 1; z < this.mixedSteps.length; z++) {
                    if(this.mixedSteps[z].selected)
                    {
                      products_in = this.filterProductsBySpecs(products_in, this.mixedSteps[z].selected);
                    }

                }
                this.mixedSteps[this.current].items = products_in;
              }
            }
          }
      }

     for (var i = 0; i < this.mixedSteps.length; i++) {
        if(this.mixedSteps[i].selected)
        {
          if(this.mixedSteps[i].items)
          {
            for (var j = 0; j < this.mixedSteps[i].items.length; j++) {
              if(this.mixedSteps[i].type == 'category' && this.mixedSteps[i].items[j].categoryId == this.mixedSteps[i].selected)
                {
                  this.mixedSteps[i].selected_image = this.mixedSteps[i].items[j].image;
                  this.mixedSteps[i].selected_title = this.mixedSteps[i].items[j].title;
                }
              if(this.mixedSteps[i].type == 'specification' && this.mixedSteps[i].items[j].specificationPropertyMasterDataId == this.mixedSteps[i].selected)
                {
                  this.mixedSteps[i].selected_image = this.mixedSteps[i].items[j].image;
                  this.mixedSteps[i].selected_title = this.mixedSteps[i].items[j].title;
                }
            }

          }
        }
      }

    },

    selectCategory(categoryId){
      
      if(this.categoryHasSpec(categoryId)) {
          if(this.mixedSteps !== this.mixedStepsOriginal) {
            this.mixedSteps = this.mixedStepsOriginal;
          }  
      } else {
          this.mixedSteps = this.mixedStepsNoSpec;
      }

      for (var i = 0; i < this.mixedSteps.length; i++) {
        if(this.mixedSteps[i+1])
        this.mixedSteps[i+1].selected = null;
      }

      if(this.solutionCategories.categories && this.solutionCategories.categories.length)
      {
        for (var i = 0; i < this.solutionCategories.categories.length; i++) {
          if(this.solutionCategories.categories[i].categoryId == categoryId)
          {
            if(this.mixedSteps && this.mixedSteps.length)
            this.mixedSteps[0].selected = this.solutionCategories.categories[i].categoryId;
            this.setUrl();
            this.slide(1);
            if (this.mixedSteps[1]) {
              if (this.mixedSteps[1].items.length == 1 && this.mixedSteps[1].items[0].specificationPropertyMasterDataId) {
                this.selectSpecification(this.mixedSteps[1].items[0].specificationPropertyMasterDataId);
              }
            }
          }
        }
      }

    },

    selectSpecification(specificationPropertyMasterDataId){
      var current = this.current;

      this.mixedSteps[current].selected = specificationPropertyMasterDataId;

      for (var i = current; i < this.mixedSteps.length; i++) {
        if(this.mixedSteps[i+1])
        this.mixedSteps[i+1].selected = null;
      }

      this.setUrl();
      this.slide(1);

      if (this.mixedSteps[current + 1]) {
        if (this.mixedSteps[current + 1].items.length == 1) {
          if (this.mixedSteps[current + 1].items[0].specificationPropertyMasterDataId) {
            setTimeout(() => {
              this.selectSpecification(this.mixedSteps[current + 1].items[0].specificationPropertyMasterDataId);
            }, 150);
          }
        }
      }
    },

    selectProduct(productId){

      console.log(productId);
    },
    categoryHasSpec(categoryId) {
    
      let blacklist = [
                      // '3B393703-FAA0-4701-A5B4-DFA329A3DC9B', // Vortex
                      // '863D439D-B6F2-48F1-BA51-9EEA6A2228E3', // Heavy Duty
                    ];
      return !blacklist.includes(categoryId);
    },
    skipStep(specId) {
      this.slide(1); 
    }
	},
};
</script>
<style lang="scss">
.mixedsteps {
  padding:25px;
  background-color: #005cb9;
  color: white;
  text-align: center;
}
.mixedsteps:before {
  /* content: '';
  display: block;
  position: absolute;
  border-left: 30px solid white;
  top: 0;
  right: -30px;
  border-bottom: 38px solid transparent;
  border-top: 38px solid transparent;
  bottom: 0;
  z-index: 1 */
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  right: -38px;
  border-right: 1px solid #ccc;
  -webkit-transform: translateY(0px) translateX(-18px) rotate(27deg);
  bottom: -5px;
  z-index: 4;
}
.mixedsteps:after {
  /* content: '';
  display: block;
  position: absolute;
  border-left: 30px solid #005cb9;
  top: 0;
  right: -29px;
  border-bottom: 38px solid transparent;
  border-top: 38px solid transparent;
  bottom: 0;
  z-index: 1 */
  content: '';
  display: block;
  position: absolute;
  background-color: transparent;
  top: 0;
  right: -40px;
  bottom: 0;
  z-index: 2;
  border-right: solid 40px transparent;
  border-top: solid 77px #005cb9;
}
.mixedsteps:last-child:before, .mixedsteps:last-child:after {
  display: none;
}

.mixedsteps.current .back:before {
  /* content: '';
  display: block;
  position: absolute;
  width: 30px;
  background-color: #005cb9;
  top: 0;
  right: -30px;
  bottom: 0;
  z-index: 0 */
  content: '';
  display: block;
  position: absolute;
  background-color: transparent;
  top: 0;
  left: -59px;
  bottom: 0;
  z-index: 2;
  border-right: solid 40px #005cb9;
  border-top: solid 77px transparent;
}

/* GO TO NEXT SLIDE */
.slide-next-enter-active,
.slide-next-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-next-enter {
  transform: translate(100%);
}
.slide-next-leave-to {
  transform: translate(-100%);
}

/* GO TO PREVIOUS SLIDE */
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-prev-enter {
  transform: translate(-100%);
}
.slide-prev-leave-to {
  transform: translate(100%);
}

/* SLIDES CLASSES */
#solution-slider {
  width: 100%;
  position: relative;
  overflow: hidden;
  height: auto;
}

.solution-slide {
  position: absolute;
  height: auto;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.solution-spec {
  position: relative;
    padding: 15px 15px 65px 15px;
    margin: 15px 0;
    border-style: solid;
    border-color: #CCC;
    border-width: 1px;
}
.solution-spec.active {
    border-color: green;
    border-width: 3px;
}

.solution-product {
  position: relative;
    padding: 15px 15px 65px 15px;
    margin: 15px 0;
    border-style: solid;
    border-color: #CCC;
    border-width: 1px;
}
.solution-product.active {
    border-color: #1F721F;
    border-width: 3px;
}
.solution-category {
    padding: 15px 15px 65px 15px;
    margin: 15px 0;
    border-style: solid;
    border-color: #CCC;
    border-width: 1px;
    position: relative;
}



.solution-spec .button, .solution-category .button {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  padding: 0 15px;
  text-align: center;
}



.solution-category.active {
    border-color: #1F721F;
    border-width: 3px;
}
.solution-category.disabled {
    display: none;
    border-color: #CCC;
    border-width: 0.5px;
    opacity: 0.4
}
span.circle,
span.text {
  font-family: "trim-regular";
}
span.circle {
  display: inline-block;
  border: 2px solid white;
  padding: 2px 0;
  border-radius: 50%;
  text-align: center;
  width: 30px;
  height: 30px;
  margin: 0 8px;
  z-index: 2;
  position: relative;
  @media (max-width: 991px) {
    margin-right: 0;
  }
}
span.text {
    z-index: 3;
    text-transform: uppercase;
    position: relative;
}

// .grey-items-1,
// .grey-items-2,
// .grey-items-3,
// .grey-items-4,
// .grey-items-5{
//   flex: 0 0 16.64%;
//   max-width: 100%;
// }

.items-1, .items-2, .items-3, .items-4, .items-5, .items-6 {
    position: relative;
    width: 100%;
    /* padding-right: 5px;
    padding-left: 5px; */
}
.grey-items-1,.items-1 {
    flex: 0 0 100%;
    max-width: 100%;
}
.grey-items-2, .items-2 {
    flex: 0 0 50%;
    max-width: 100%;
}
.grey-items-3, .items-3 {
    flex: 0 0 33.3333333%;
    max-width: 100%;
}
.grey-items-4, .items-4 {
    flex: 0 0 25%;
    max-width: 100%;
}
.grey-items-5, .items-5 {
    flex: 0 0 20%;
    max-width: 100%;
}
.grey-items-6, .items-6 {
    flex: 0 0 16.6666666667%;
    max-width: 100%;
    letter-spacing: -1px;
}
.orange-bar {
  padding-top:25px;
  margin: 0 auto;
  overflow: hidden;
}
.grey-bar {
    overflow: hidden;
    margin: 0 auto;
    /* padding: 10px 0;
    border: 1px solid #EEE; */
}

.solution-title {
  margin-top: 50px;
}

.selected_image {
    width: 80px;
    height: 44px;
    border: 1px solid #CCC;
    margin: 5px auto;
    position: relative;
    display: block;
}
.placeholder_image {
    border: 1px dashed #CCC;
    width: 80px;
    height: 44px;
    margin: 5px auto;
    position: relative;
    display: block;
}
.selected_text {
  font-size: 12px;
  text-align: center;
  display: block;
  letter-spacing: 1px;
}

.grey-items-1 {
  border-left: 1px solid #ccc;
}

.grey-items-1:first-child, .grey-items-2:first-child, .grey-items-3:first-child, .grey-items-4:first-child, 
.grey-items-5:first-child, .grey-items-6:first-child{
    border-left: 1px solid #ccc;
}

.bar-item-added {
  border-bottom: 1px solid #ccc;
  background-color: #F7F7F7;
}
.bar-item-added:before {
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  right: 0;
  border-right: 1px solid #ccc;
  -webkit-transform: translateY(0px) translateX(-18px) rotate(27deg);
  bottom: -5px;
  z-index: 4;
  
}

.bar-items:after {
  content: "";
  display: block;
  position: absolute;
  background-color: transparent;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  border-right: solid 40px white;
  border-top: solid 77px transparent;
}

.grey-bar .pointer {
  /* content: '+'; */
  /* display: block;
  position: absolute;
  top: 50%;
  right: -10px;
  font-size: 22px;
  line-height: 0;
  color: #999; */
}

.grey-bar .pointer:last-child:before {
 border-right: inherit;
}
.pointer {
  cursor: pointer;
  position: relative;
}
.colour {
    width: 40px;
    height: 40px;
    display: block;
    position: absolute;
    top: 20px;
    left: 20px;
}
.solutions .solution-product .features div {
  float: none;
}
.solutions hr {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.solution-spec .icon {
    width: 38px;
    display: inline-block;
}
.text-right {
    text-align: right;
}
.btn-vue-prev {
    position: absolute;
    top: 50%;
    left: -90px;
}
.btn-vue-next {
    position: absolute;
    top: 50%;
    right: -90px;
}
.select-text {
  display: none;
  padding-bottom: 10px;
}
.active .solution-spec {
  border: 3px solid #1F721F;
}
@media (min-width: 992px) {
  .mixedsteps.active {
    background-color: #014589;
    span.circle {
      color: #014589;
      background-color: #ffffff;
    }
  }
  .mixedsteps.active:before {
  /* content: '';
  display: block;
  position: absolute;
  border-left: 30px solid #014589;
  top: 0;right: -29px;
  border-bottom: 38px solid transparent;
  border-top: 38px solid transparent;
  bottom: 0;
  z-index: 1 */
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  right: -38px;
  border-right: 1px solid #ccc;
  -webkit-transform: translateY(0px) translateX(-18px) rotate(27deg);
  bottom: -5px;
  z-index: 4;
}

.mixedsteps.active:after {
  content: "";
  display: block;
  position: absolute;
  background-color: transparent;
  top: 0;
  right: -40px;
  bottom: 0;
  z-index: 2;
  border-right: solid 40px transparent;
  border-top: solid 77px #014589;
}

.mixedsteps.active:last-child:before, .mixedsteps.active:last-child:after {
  display: none;
}

}
@media (max-width: 991px) {
  .solutions .text, .solutions .grey-bar {
    display: none;
  }
  .select-text {
    display: block;
    text-align: center;
  }
  .orange-bar {
    margin-bottom: 10px;
  }
  .mixedsteps:before, .mixedsteps.active:before {
    // right: -3px;
    // border-left-width: 20px;
    // border-bottom-width: 28px;
    // border-top-width: 28px;
    right: -16px;
    top: -1px;
    -webkit-transform: translateY(0px) translateX(-11px) rotate(11deg);
  }

  .mixedsteps:after {
    right: -10px;
    border-right: solid 10px transparent;
    border-top: solid 57px #005cb9;
  }
  .mixedsteps.active:after {
    // right: -2px;
    // border-left-width: 20px;
    // border-bottom-width: 28px;
    // border-top-width: 28px;
    right: -10px;
    border-right: solid 10px #005cb9;
    border-top: solid 57px #014589;
  }
  .mixedsteps.current:first-child .back:before {
    display: none;
  }
  .mixedsteps.current .back:before {
    left: 0;
    border-right: solid 10px #014589;
    border-top: solid 57px transparent;
  }
  .orange-bar {
    padding-top:5px;
  }
  .mixedsteps {
    padding: 15px;
  }
  .solution-category {
    margin: 5px 0px;
  }
  .mixedsteps.active,
  .mixedsteps.active .circle {
    background-color: #014589;
  }
}
.long-title {
  margin-left: -4rem;
}
</style>
